// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"afda299d","387":"273e7fc2","552":"83051382","556":"c1b9df53"}[chunkId] + ".chunk.css";
};